var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- components/bill-list/index--><h1>Заявки</h1><component is=\"zayavki-list\"></component><component is=\"modal-dialog\" data-show=\"{{@ modal.show }}\" data-name=\"{{@ name }}\" data-components=\"{{ modal.components }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/zayavki-list/template.jade
 ** module id = 126
 ** module chunks = 0
 **/